import React, { useState, Suspense } from "react";
import ReactDOM from "react-dom";
import { Chat } from "~/common/Store/models/Chat";
import useIsMounted from "~/common/useIsMounted";
import connectUserAndChat from "~/common/Store/connectUserAndChat";
import ChatLink from "./ChatLink";
interface Props {
  chat: Chat;
  itemNumber: string;
}
import("~/bootstrap/less/modals-standalone.less");
const PriceGuaranteeModal = React.lazy(() => import("~/common/PriceGuaranteeModalContainer/index"));
const LowestPriceGuarantee = connectUserAndChat(({
  chat,
  itemNumber
}: Props) => {
  const [modalOpen, setModalOpen] = useState(false);
  const isMounted = useIsMounted();
  const {
    statusText
  } = chat;
  return <>
        {statusText && statusText === "online" ? <ChatLink className="map__text map__link" data-item-number={itemNumber}>
            <p className="text__highlight">Lowest Price Guarantee</p>
            <p className="text__small">
              Chat Now&nbsp;
              <i className="icon-breadcrumb" />
            </p>
          </ChatLink> : <a className="map__text map__link" data-item-number={itemNumber} href="##" onClick={e => {
      e.preventDefault();
      setModalOpen(true);
    }}>
            <p className="text__highlight">Lowest Price Guarantee</p>
            <p className="text__small">
              Request Quote&nbsp;
              <i className="icon-breadcrumb" />
            </p>
          </a>}
        {isMounted && <>
            {ReactDOM.createPortal(<Suspense fallback={null}>
                <PriceGuaranteeModal modalOpen={modalOpen} onClose={() => setModalOpen(false)} itemNumber={itemNumber} />
              </Suspense>,
      // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
      document.querySelector("body") as Element)}
          </>}
      </>;
});
export default LowestPriceGuarantee;